import css from 'styled-jsx/css';

const styles = css.global`
.custom-carousel.fill-height, .custom-carousel .fill-height {
    width: 100%;
}
.custom-tabs.tabs-container .tab-item {
    flex: 0 0 161px !important;
}
.custom-tabs.tabs-container .tab-item.sf-tab-emprestimo-com-garantia {
    flex: 0 0 234px !important;
}

.custom-tabs.tabs-container {
    padding: 32px 15px 24px;
}


/* @media (min-width: 576px) {
    .custom-tabs.tabs-container .tab-item {
        flex: 0 0 161px !important;
    }
    .custom-tabs.tabs-container .tab-item.tab-emprestimo {
        flex: 0 0 234px !important;
    }
} */

@media (min-width: 992px) {
    .custom-tabs.tabs-container {
        padding: 32px 15px 32px;
    }
}
`;

export default styles;